function flask(liquidColor: string, corkColor: string = '#8B6914', bubbles: boolean = false, size: number = 32): string {
  const svg = `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Cork -->
    <rect x="12" y="3" width="8" height="5" rx="1" fill="${corkColor}" stroke="rgba(0,0,0,0.2)" stroke-width="0.8"/>
    <!-- Neck -->
    <rect x="13" y="7" width="6" height="4" fill="rgba(200,220,255,0.5)" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <!-- Flask body -->
    <path d="M13,11 L8,18 Q6,22 6,25 Q6,29 10,29 L22,29 Q26,29 26,25 Q26,22 24,18 L19,11 Z" fill="rgba(200,220,255,0.35)" stroke="rgba(0,0,0,0.2)" stroke-width="1"/>
    <!-- Liquid -->
    <path d="M9,20 Q7,24 8,28 Q8,29 10,29 L22,29 Q24,29 24,28 Q25,24 23,20 Z" fill="${liquidColor}" opacity="0.8"/>
    <!-- Liquid highlight -->
    <path d="M10,22 Q12,20 14,22" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="1"/>
    <!-- Glass highlight -->
    <path d="M10,14 L9,22" stroke="rgba(255,255,255,0.3)" stroke-width="1.5" stroke-linecap="round"/>
    ${bubbles ? `
    <circle cx="14" cy="24" r="1" fill="rgba(255,255,255,0.5)"/>
    <circle cx="18" cy="22" r="0.8" fill="rgba(255,255,255,0.4)"/>
    <circle cx="16" cy="26" r="1.2" fill="rgba(255,255,255,0.35)"/>
    ` : ''}
  </svg>`;
  return svg;
}

export const POTION_ICONS: Record<string, (size?: number) => string> = {
  red_potion: (s) => flask('#cc2222', '#8B6914', false, s),
  orange_potion: (s) => flask('#ff8c00', '#8B6914', false, s),
  blue_potion: (s) => flask('#2266cc', '#8B6914', false, s),
  power_elixir: (s) => flask('#ffdd00', '#8B6914', true, s),
};
